<template>
  <page-option title="Dữ liệu sao lưu">
    <template v-slot:toolbar-btns>
      <base-button
        class="text-capitalize"
        icon
        @click="create"
        tooltip="Tạo sao lưu"
        :loading="loadingCreate"
      >
        <v-icon class="mr-1">mdi-database-plus-outline</v-icon>
      </base-button>
      <base-button
        class="text-capitalize"
        icon
        @click="restore"
        tooltip="Khôi phục hệ thống"
        :loading="loadingRestore"
      >
        <v-icon class="mr-1">mdi-restore</v-icon>
      </base-button>
      <!-- <base-button
          class="text-capitalize"
          text
          @click="goEditTime"
          tooltip="Thiết lập thời gian sao lưu"
        >
          <v-icon class="mr-1">mdi-database-clock-outline </v-icon>
        </base-button> -->
    </template>
    <base-serve-table
      ref="table"
      :api="api"
      :headers="headers"
      :params="params"
      :defaultParams="default_params"
    >
      <template v-slot:[`item.created_at`]="{ item }">
        {{ item.created_at | calcDate }}
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              @click="download(item)"
              icon
              v-on="on"
              style="margin-left: -8px"
              :disabled="loadingDownload"
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <span>Tải xuống</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn @click="remove(item)" icon color="primary" v-on="on">
              <v-icon> mdi-trash-can </v-icon>
            </v-btn>
          </template>
          <span>Xoá</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.last_modified`]="{ item }">
        {{ handleDate(item.last_modified) }}
      </template>
    </base-serve-table>
    <RestoreDialog ref="restore_dialog" />
  </page-option>
</template>
<script>
import sdk from '@src/service/auth-sdk'
import { saveAs } from 'file-saver'
import { API_BACKUP } from '@api'
import { ConfirmBuilder } from '@utils'
import RestoreDialog from './restore-dialog.vue'
export default {
  components: { RestoreDialog },
  data: () => ({
    api: API_BACKUP,
    items: [],
    headers: [
      { text: 'Tên File', value: 'name', sortable: false },
      { text: 'Dung lượng', value: 'size', sortable: false },
      { text: 'Ngày tạo', value: 'created_at', sortable: false },
      { text: 'Hoạt động', value: 'action', sortable: false },
    ],
    loading: false,
    loadingDownload: false,
    loadingCreate: false,
    default_params: {},
    params: { search: '', inactive: null },
    months: {
      January: 'Tháng 1',
      February: 'Tháng 2',
      March: 'Tháng 3',
      April: 'Tháng 4',
      May: 'Tháng 5',
      June: 'Tháng 6',
      July: 'Tháng 7',
      August: 'Tháng 8',
      September: 'Tháng 9',
      October: 'Tháng 10',
      November: 'Tháng 11',
      December: 'Tháng 12',
    },
    loadingRestore: false,
  }),
  created() {
    // this.fetchData()
  },
  methods: {
    async download(item) {
      try {
        this.loadingDownload = true
        const res = await this.api.download(item.id)
        if (res && res.isDone) {
          saveAs(new Blob([res.data]), item.name)
        }
      } finally {
        this.loadingDownload = false
      }
    },
    async remove(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .addMessage('confirm.delete-name')
        .setTitle('confirm.title')
        .setOption({
          params: {},
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        const result = await this.api.destroy(item.id)
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    onReset() {
      this.$refs.table.reload()
    },
    async create() {
      this.loadingCreate = true
      const res = await this.api.backup()
      // this.onReset()
      this.loadingCreate = false
    },
    goEditTime() {},
    restore() {
      this.$refs.restore_dialog.open()
    },
  },
}
</script>
